module.exports = __webpack_public_path__ + "img/img06.60617f1f.svg";